import Layout from "../../components/feature/Layout";
import { useNavigate } from "react-router-dom";

export default function Reports() {
  const navigate = useNavigate();

  const reportCategories = [
    {
      title: "Reportes Operativos",
      icon: "ri-ship-line",
      color: "text-[#2F80ED]",
      bgColor: "bg-[#2F80ED]/10",
      description: "Análisis del core aduanero y operaciones",
      path: "/reports/operational",
      reports: 8,
      stats: { total: 127, enProceso: 45, completadas: 82 }
    },
    {
      title: "Reportes Financieros",
      icon: "ri-money-dollar-circle-line",
      color: "text-[#10B981]",
      bgColor: "bg-[#10B981]/10",
      description: "Análisis financiero y contable desde ERP",
      path: "/reports/financial",
      reports: 7,
      stats: { ingresos: "$2.8M", egresos: "$1.9M", utilidad: "$898K" }
    },
    {
      title: "Reportes Comerciales",
      icon: "ri-bar-chart-box-line",
      color: "text-[#EAB308]",
      bgColor: "bg-[#EAB308]/10",
      description: "Análisis de ventas y CRM",
      path: "/reports/commercial",
      reports: 5,
      stats: { clientes: 248, oportunidades: 23, conversion: "68%" }
    },
    {
      title: "Reportes de Clientes",
      icon: "ri-user-star-line",
      color: "text-[#8B5CF6]",
      bgColor: "bg-[#8B5CF6]/10",
      description: "Análisis detallado por cliente",
      path: "/reports/clients",
      reports: 5,
      stats: { activos: 248, nuevos: 12, ranking: "Top 10" }
    },
    {
      title: "Reportes de Gestores",
      icon: "ri-team-line",
      color: "text-[#F59E0B]",
      bgColor: "bg-[#F59E0B]/10",
      description: "Desempeño y productividad del equipo",
      path: "/reports/managers",
      reports: 5,
      stats: { gestores: 12, eficiencia: "94%", sla: "92%" }
    },
    {
      title: "Reportes de Incidencias",
      icon: "ri-error-warning-line",
      color: "text-[#EF4444]",
      bgColor: "bg-[#EF4444]/10",
      description: "Análisis de problemas y resoluciones",
      path: "/reports/incidents",
      reports: 4,
      stats: { total: 45, resueltas: 38, pendientes: 7 }
    },
    {
      title: "Reportes de Productividad",
      icon: "ri-dashboard-line",
      color: "text-[#06B6D4]",
      bgColor: "bg-[#06B6D4]/10",
      description: "Métricas de eficiencia operativa",
      path: "/reports/productivity",
      reports: 4,
      stats: { tareas: 342, completadas: 298, backlog: 44 }
    },
    {
      title: "Diseñador de Reportes",
      icon: "ri-layout-grid-line",
      color: "text-[#0A2A43]",
      bgColor: "bg-[#0A2A43]/10",
      description: "Constructor visual de reportes personalizados",
      path: "/reports/designer",
      reports: 0,
      stats: { plantillas: 15, personalizados: 8, compartidos: 5 }
    },
  ];

  return (
    <Layout>
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-[#0A2A43]">Centro de Reportes</h1>
            <p className="text-sm text-gray-500 mt-1">Análisis ejecutivo y reportes globales de la plataforma</p>
          </div>
        </div>

        {/* KPIs Globales */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div className="bg-white rounded-lg shadow-[0_4px_16px_rgba(10,42,67,0.08)] p-5">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500 mb-1">Reportes Disponibles</p>
                <p className="text-2xl font-bold text-[#0A2A43]">38</p>
                <p className="text-xs text-[#10B981] mt-1">8 categorías</p>
              </div>
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#EAF2F8]">
                <i className="ri-file-chart-line text-2xl text-[#2F80ED]"></i>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-[0_4px_16px_rgba(10,42,67,0.08)] p-5">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500 mb-1">Reportes Generados</p>
                <p className="text-2xl font-bold text-[#0A2A43]">1,247</p>
                <p className="text-xs text-[#10B981] mt-1">+18% vs mes anterior</p>
              </div>
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#EAF2F8]">
                <i className="ri-file-download-line text-2xl text-[#10B981]"></i>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-[0_4px_16px_rgba(10,42,67,0.08)] p-5">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500 mb-1">Reportes Programados</p>
                <p className="text-2xl font-bold text-[#0A2A43]">24</p>
                <p className="text-xs text-gray-500 mt-1">Envío automático</p>
              </div>
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#EAF2F8]">
                <i className="ri-calendar-schedule-line text-2xl text-[#EAB308]"></i>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-[0_4px_16px_rgba(10,42,67,0.08)] p-5">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500 mb-1">Plantillas Personalizadas</p>
                <p className="text-2xl font-bold text-[#0A2A43]">15</p>
                <p className="text-xs text-[#10B981] mt-1">+3 este mes</p>
              </div>
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#EAF2F8]">
                <i className="ri-layout-grid-line text-2xl text-[#0A2A43]"></i>
              </div>
            </div>
          </div>
        </div>

        {/* Categorías de Reportes */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {reportCategories.map((category, index) => (
            <div 
              key={index} 
              className="bg-white rounded-lg shadow-[0_4px_16px_rgba(10,42,67,0.08)] p-6 hover:shadow-xl transition-all cursor-pointer group"
              onClick={() => navigate(category.path)}
            >
              <div className="flex items-start gap-4">
                <div className={`w-14 h-14 flex items-center justify-center rounded-lg ${category.bgColor} flex-shrink-0`}>
                  <i className={`${category.icon} text-2xl ${category.color}`}></i>
                </div>
                <div className="flex-1">
                  <div className="flex items-start justify-between mb-2">
                    <div>
                      <h2 className="text-lg font-bold text-[#0A2A43] group-hover:text-[#2F80ED] transition-colors">{category.title}</h2>
                      <p className="text-sm text-gray-500 mt-1">{category.description}</p>
                    </div>
                    <i className="ri-arrow-right-line text-xl text-gray-400 group-hover:text-[#2F80ED] transition-colors"></i>
                  </div>
                  
                  <div className="flex items-center gap-4 mt-4 pt-4 border-t border-gray-100">
                    <div className="flex items-center gap-2">
                      <i className="ri-file-list-line text-gray-400"></i>
                      <span className="text-sm text-gray-600">{category.reports} reportes</span>
                    </div>
                    <div className="flex items-center gap-3 text-xs text-gray-500">
                      {Object.entries(category.stats).map(([key, value], i) => (
                        <span key={i} className="flex items-center gap-1">
                          <span className="font-medium text-[#0A2A43]">{String(value)}</span>
                          <span className="capitalize">{key}</span>
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Reportes Recientes */}
        <div className="bg-white rounded-lg shadow-[0_4px_16px_rgba(10,42,67,0.08)] p-6">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-bold text-[#0A2A43]">Reportes Generados Recientemente</h2>
            <button className="text-sm text-[#2F80ED] hover:underline cursor-pointer">Ver todos</button>
          </div>
          <div className="space-y-3">
            {[
              { name: "Operaciones por Estado", category: "Operativo", date: "Hace 2 horas", user: "María González", format: "PDF" },
              { name: "Facturación Mensual", category: "Financiero", date: "Hace 4 horas", user: "Carlos Ramírez", format: "Excel" },
              { name: "Ranking de Clientes", category: "Clientes", date: "Hace 6 horas", user: "Ana Torres", format: "PDF" },
              { name: "Desempeño de Gestores", category: "Gestores", date: "Hace 8 horas", user: "Luis Mendoza", format: "Excel" },
            ].map((report, i) => (
              <div key={i} className="flex items-center justify-between p-4 border border-gray-200 rounded-lg hover:border-[#2F80ED] hover:shadow-md transition-all cursor-pointer">
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-[#EAF2F8]">
                    <i className={`ri-file-${report.format === 'PDF' ? 'pdf' : 'excel'}-line text-xl ${report.format === 'PDF' ? 'text-[#EF4444]' : 'text-[#10B981]'}`}></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-[#0A2A43]">{report.name}</h3>
                    <div className="flex items-center gap-3 mt-1">
                      <span className="text-xs text-gray-500">{report.category}</span>
                      <span className="text-xs text-gray-400">•</span>
                      <span className="text-xs text-gray-500">{report.date}</span>
                      <span className="text-xs text-gray-400">•</span>
                      <span className="text-xs text-gray-500">Por {report.user}</span>
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <button className="w-8 h-8 flex items-center justify-center text-[#2F80ED] hover:bg-[#EAF2F8] rounded-md transition-colors cursor-pointer">
                    <i className="ri-download-line"></i>
                  </button>
                  <button className="w-8 h-8 flex items-center justify-center text-[#2F80ED] hover:bg-[#EAF2F8] rounded-md transition-colors cursor-pointer">
                    <i className="ri-share-line"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
}
